import { useSnackbar } from "notistack"
import React from "react"
import Package from "../../../../package.json"

import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import semPedidos_IMG from "../../../assets/ilustration/Money Save Illustration.svg"
import RowPagamentos from "./RowPagamentos"

import VisualizarPedido from "./visualizarPedido"

import { Print } from "@material-ui/icons"
import { Button } from "react-bootstrap"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { buscarInformacoesPedido } from "../../../services/integracao"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"

const useStyles = makeStyles(theme => ({
    img: {},
    texto: {
        textAlign: "center",
        position: "relative",
        top: "-1rem",
    },
}))

export default function TablePagamentos(props) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()

    const { caixaSelecionada } = props

    const configuracoes = useAppStore(s => s.configuracoes)
    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    const setLoading = useLoadingStore(s => s.setLoading)

    const [open, setOpen] = React.useState(-1)
    const [modalPedido, setModalPedido] = React.useState({})

    const classes = useStyles()

    const buscarPedido = async id => {
        try {
            setLoading(true)
            const pedido = await buscarInformacoesPedido(
                autorizacao,
                id,
                configuracoes.user.parametros
            )
            console.log("pedido", pedido)
            if (pedido.retornoErro) {
                enqueueSnackbar(pedido.mensagem)
            } else {
                setModalPedido(pedido)
            }
        } catch (error) {
            enqueueSnackbar(
                Package.version + "buscarInformacoesPedido - ${window.location.hostname} - ${error}"
            )
            RegistrarLogErro(error, "buscarInformacoesPedido", id)
        }
        setLoading(false)
    }

    const formatBRL = (v = 0) =>
        new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
            Number(v) || 0
        )
    const line = (n = 48, ch = "-") => ch.repeat(n)
    const pad = (s = "", w, side = "end") =>
        (s + "").slice(0, w)[side === "end" ? "padEnd" : "padStart"](w, " ")

    const gerarTextoNotinha = caixa => {
        const colunasPorLinhaImpressao = configuracoes.user.parametros.colunasPorLinhaImpressao

        const pedidos = Array.isArray(caixa?.pedidosDoCaixa) ? caixa.pedidosDoCaixa : []

        const grupos = new Map()
        pedidos.forEach(p => {
            const k = p.formaPagamento || "N/D"
            if (!grupos.has(k)) grupos.set(k, { itens: [], total: 0 })
            grupos.get(k).itens.push(p)
            grupos.get(k).total += Number(p.valor || 0)
        })

        const formasOrdenadas = [...grupos.keys()].sort((a, b) => a.localeCompare(b, "pt-BR"))

        let texto = `${line(colunasPorLinhaImpressao, "=")}\n\n\n`
        texto += "Fechamento de Caixa\n"
        texto += `${line(colunasPorLinhaImpressao, "=")}\n`
        texto += `Dinheiro inicial: ${formatBRL(caixa?.dinheiroInicial || 0)}\n`
        texto += `Vendas:  ${formatBRL(caixa?.somaVenda || 0)}\n`
        texto += `Retirada:  ${formatBRL(caixa?.totalSangriaCaixa || 0)}\n`
        texto += `Adicionado:  ${formatBRL(caixa?.totalInjecaoCaixa || 0)}\n`
        texto += `Valor em Caixa:  ${formatBRL(caixa?.somaDinheiroEmCaixa || 0)}\n`
        texto += line(colunasPorLinhaImpressao) + "\n"

        formasOrdenadas.forEach(fp => {
            const g = grupos.get(fp)
            texto += `${g.itens.length}x ${fp.toUpperCase()}\n`
            texto +=
                pad("Total", colunasPorLinhaImpressao - formatBRL(g.total).length - 1) +
                " " +
                formatBRL(g.total) +
                "\n"
        })

        return texto
    }

    const imprimir = () => {
        const texto = gerarTextoNotinha(caixaSelecionada)
        mandarImprimir({ texto: texto, numeroDaImpressora: 1 })
    }

    return (
        <>
            {caixaSelecionada.pagamentos.length > 0 && (
                <Button
                    style={{
                        backgroundColor: "blue",
                        color: "white",
                        marginBottom: "0.5em",
                    }}
                    onClick={() => {
                        imprimir()
                    }}
                    size="small"
                    className={classes.button}
                >
                    <Typography>
                        <Print /> Imprimir
                    </Typography>
                </Button>
            )}
            <TableContainer component={Paper}>
                {caixaSelecionada.pagamentos.length > 0 ? (
                    <Table aria-label="collapsible table">
                        <VisualizarPedido pedido={modalPedido} setModalPedido={setModalPedido} />
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Forma Pagamento</TableCell>
                                <TableCell align="right">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {caixaSelecionada.pagamentos?.map((pagamento, index) => (
                                <RowPagamentos
                                    buscarPedido={buscarPedido}
                                    key={index}
                                    index={index}
                                    open={open}
                                    setOpen={setOpen}
                                    pagamento={pagamento}
                                    pedidos={caixaSelecionada.pedidosDoCaixa.filter(
                                        pedido => pagamento.descricao === pedido.formaPagamento
                                    )}
                                />
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <div>
                        <img
                            src={semPedidos_IMG}
                            className={classes.img}
                            alt="sem pedidos associados a esse caixa"
                        />
                        <Typography className={classes.texto}>
                            Você ainda não recebeu pedidos associados a esse caixa.
                        </Typography>
                    </div>
                )}
            </TableContainer>
        </>
    )
}
